module.exports = __webpack_public_path__ + "static/media/city4.126ace39.jpg";